import { render, staticRenderFns } from "./#salary.vue?vue&type=template&id=74400d7e&"
import script from "./#salary.vue?vue&type=script&lang=js&"
export * from "./#salary.vue?vue&type=script&lang=js&"
import style0 from "./#salary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports